// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1CXHa","box":"WorkspacesBox_box__2Lt6n","node":"WorkspacesBox_node__YIUhi"};